import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader, Form, FormGroup, Label, Input, Button,
        ListGroup, ListGroupItem, Badge, Card, CardBody, CardTitle, Progress, Row, Col} from 'reactstrap';

import CalendarHeatmap from 'react-calendar-heatmap';
import PasswordInputComponent from  '../PasswordInputComponent';
/* import {Doughnut} from 'react-chartjs-2'; */

import 'react-datepicker/dist/react-datepicker.css';

import {serverPath, convertDate, monthLabels} from "../common.js";
import axios from 'axios';

import "../../css/studentPage.css"
import "../../css/homepage.css"



class StudentPage extends Component{

    constructor(props){
        super(props);

        this.state={
            userData: null,
            userActivity: [],
            userSuccess: [],
            loggedUser: null,
            validUsername: true,
            numOfProblems : 0,
            //edit info modal
            isEditModalOpen: false,
            //new information
            image: null,

            //error handling
            emailValidClass:"",
            websiteValidClass:"",
            linkedinValidClass:"",
            githubValidClass:"",
            dateOfBirthValidClass:"",
            badInput: "",

            //change password
            passwordModalOpen: false,
            changePasswordMessage: "",
        };
        this.toggleEditModal = this.toggleEditModal.bind(this);
        this.handleEditDone = this.handleEditDone.bind(this);
        this.handleImageSelect = this.handleImageSelect.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.togglePasswordModal = this.togglePasswordModal.bind(this);
        this.onValidPassword = this.onValidPassword.bind(this);
        this.onInvalidPassword = this.onInvalidPassword.bind(this);
    }
    getData(){
        axios.get(serverPath + "userService.php", {params:{
            action:'getUserInfo',
            username:this.props.match.params.username,
        }}).then((response)=>{
            if(response.data.hasOwnProperty("validUsername") && response.data.validUsername === false){
                this.setState({validUsername:false,});
                return;
            }
            this.setState({
                userData: response.data.userData,
                loggedUser: response.data.loggedUser,
                numOfProblems : response.data.numOfProblems,
            });
        });
    }
    componentDidMount(){
        this.getData();
    }
    toggleEditModal(){
        this.setState({
            isEditModalOpen: !this.state.isEditModalOpen,
            emailValidClass:"",
            websiteValidClass:"",
            linkedinValidClass:"",
            githubValidClass:"",
            dateOfBirthValidClass :"",
            badInput: "",
            passwordModalOpen:false,
        });
    }

    handleImageSelect(event){
        this.setState({image:event.target.files[0]});
    }


    handleEditDone(){
        const params = new FormData();

        var payload = {
            'username': this.props.match.params.username,
            'firstName': this.firstName.value       !== '' ? this.firstName.value : null,
            'lastName': this.lastName.value         !== '' ? this.lastName.value : null,
            'dateOfBirth': this.dateOfBirth.value   !== '' ? this.dateOfBirth.value : null,
            'website': this.website.value           !== '' ? this.website.value : null,
            'email': this.email.value               !== '' ? this.email.value : null,
            'linkedin': this.linkedin.value         !== '' ? this.linkedin.value : null,
            'github': this.github.value             !== '' ? this.github.value : null,
            'imagePath': this.state.userData.userInfo.image,//used as default path if image is not selected
        };
        params.append('action', 'postUserInfo');
        params.append('payload', JSON.stringify(payload));

        params.append('image', this.state.image);//if image is null(not selected) $_FILES will be empty, so this is valid
        //validation is only on server side
        axios.post(serverPath + "userService.php", params).then((response)=>{
            if(response.data.hasOwnProperty('isValid') && response.data.isValid === false){//serverSide check has fired bad input
                let emailTaken = response.data.hasOwnProperty('emailTaken');
                this.setState({
                    badInput : "LOŠ UNOS!" + (emailTaken ? "\nIZABRANI EMAIL JE ZAUZET!" : ""),
                    emailValidClass:response.data.hasOwnProperty('email') ? response.data.email : "",
                    websiteValidClass:response.data.hasOwnProperty('website') ? response.data.website : "",
                    linkedinValidClass:response.data.hasOwnProperty('linkedin') ? response.data.linkedin : "",
                    githubValidClass:response.data.hasOwnProperty('github') ? response.data.github : "",
                    dateOfBirthValidClass:response.data.hasOwnProperty('dateOfBirth') ? response.data.dateOfBirth : "",
                });
            }
            else{
                this.toggleEditModal();
                window.location.reload();
            }
        });

    }
    togglePasswordModal(){
        this.setState({
            passwordModalOpen: !this.state.passwordModalOpen,
            newPassword: "",
            changePasswordMessage: "",
        });
    }
    handleChangePassword(){
        const pass = this.state.newPassword;
        if(pass !== ""){
            const self = this;
            const params = new URLSearchParams();
            params.append('action', "changePassword");
            params.append('newPassword', pass);
            axios.post(serverPath + "authService.php", params).then((resp)=>{
                self.setState({
                    changePasswordMessage: "Šifra uspešno promenjena!",
                })
            });
        }

    }
    onValidPassword(pass){
        this.setState({
            newPassword: pass,
        })
    }
    onInvalidPassword(){
        this.setState({
            newPassword:"",
        })
    }
    render(){
        var date = new Date();
        date.setFullYear(new Date().getFullYear() - 15);
        if(this.state.validUsername === false){//if invalid username (not in db) is entered in url
            return(
                <React.Fragment>
                    <h1>Nepostojeće korisničko ime!</h1>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <ShowUserInfo   userData={this.state.userData}
                                showEditButton={this.state.loggedUser !== null && 
                                                this.state.loggedUser === this.props.match.params.username}
                                editCallback={this.toggleEditModal}
                                numOfProblems={this.state.numOfProblems}/>
                <Modal isOpen={this.state.passwordModalOpen}
                        toggle={this.togglePasswordModal}>
                    <ModalHeader toggle={this.togglePasswordModal}>
                        Promenite vašu šifru
                    </ModalHeader>
                    <ModalBody>
                        <PasswordInputComponent
                            onValidPassword={this.onValidPassword}
                            onInvalidPassword={this.onInvalidPassword}/>
                        <Button color={'primary'}
                                onClick={this.handleChangePassword}>
                            Promenite šifru
                        </Button>
                        <h4>{this.state.changePasswordMessage}</h4>
                    </ModalBody>

                </Modal>
                <Modal  isOpen = {this.state.isEditModalOpen}
                        toggle = {this.toggleEditModal}>
                    
                    <ModalHeader toggle = {this.toggleEditModal}>
                        <Row>
                            <Col>
                                Izmenite svoje podatke
                            </Col>
                            <Col>
                                <Button color={'primary'}
                                        onClick={this.togglePasswordModal}>Promenite sifru</Button>
                            </Col>
                        </Row>
                    </ModalHeader>

                    <ModalBody>
                        {this.state.badInput}
                        <Form>
                            <FormGroup>
                                <Label htmlFor="firstName">Ime</Label>
                                <Input type='text' id='firstName' name='firstName'
                                        innerRef={(input) => this.firstName = input}
                                        defaultValue = {this.state.userData !== null ?
                                                        this.state.userData.userInfo.firstName : ""}/>
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="lastName">Prezime</Label>
                                <Input type='text' id='lastName' name='lastName'
                                        innerRef={(input) => this.lastName = input}
                                        defaultValue = {this.state.userData !== null ?
                                                        this.state.userData.userInfo.lastName : ""}/>
                            </FormGroup>
                            <FormGroup>
                                 <Label htmlFor="dateOfBirth">Datum rođenja</Label>
                                <Input type='date' id='dateOfBirth' name='dateOfBirth'
                                        innerRef={(input) => this.dateOfBirth = input}
                                        defaultValue = {this.state.userData !== null ?
                                                    this.state.userData.userInfo.dateOfBirth : ""}
                                        className={this.state.dateOfBirthValidClass}
                                        min = {"1970-01-01"}
                                        max = {date.getFullYear()+"-12-31"}/>

                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="email">Mail adresa</Label>
                                <Input type='text' id='email' name='email'
                                        innerRef={(input) => this.email = input}
                                        defaultValue = {this.state.userData !== null ?
                                                        this.state.userData.userInfo.email : ""}
                                        placeholder={'you@host.com'}
                                        className={this.state.emailValidClass}/>
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="website">Vaša website stranica</Label>
                                <Input type='text' id='website' name='website'
                                        innerRef={(input) => this.website = input}
                                        defaultValue = {this.state.userData !== null ?
                                                        this.state.userData.userInfo.websiteURL : ""}
                                        placeholder={'http[s]://www.yourAdress.com'}
                                        className={this.state.websiteValidClass}/>
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="linkedin">Linkedin korisničko ime</Label>
                                <Input type='text' id='linkedin' name='linkedin'
                                        innerRef={(input) => this.linkedin = input}
                                        defaultValue = {this.state.userData !== null ?
                                                        this.state.userData.userInfo.linkedin : ""}
                                        className={this.state.linkedinValidClass}/>
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="github">Github korisničko ime</Label>
                                <Input type='text' id='github' name='github'
                                        innerRef={(input) => this.github = input}
                                        defaultValue = {this.state.userData !== null ?
                                                        this.state.userData.userInfo.github : ""}
                                        className={this.state.githubValidClass}/>
                            </FormGroup>
                            <FormGroup>
                                <Label htmlFor="picture">Slika</Label>
                                <br/>
                                <input  type='file' accept={"image/*"} id='picture' name='picture'
                                        onChange={(e)=>{this.handleImageSelect(e)}}/>
                            </FormGroup>
                            <Button type='button' color='primary' value='submit' onClick={()=>this.handleEditDone()}>
                                Gotovo
                            </Button>
                        </Form>
                    </ModalBody>
                </Modal>
                
            </React.Fragment>
        );
    }
}

function ShowUserInfo({userData, showEditButton, editCallback, numOfProblems}){
    if(userData !== null){
        var imgPath = userData.userInfo.image !== null ? userData.userInfo.image : userData.userInfo.fallback;
        var endDate = new Date();
        var startDate = new Date();
        startDate.setFullYear(startDate.getFullYear()-1);

        var userTotalSubmissionsForRate = userData.userIncorrectSubmissions.count + userData.userTotalSolved.count;

        var userAcceptanceRate;
        if(userTotalSubmissionsForRate !== 0){
            userAcceptanceRate= Math.round((userData.userTotalSolved.count/userTotalSubmissionsForRate)*100);
        }
        else{
            userAcceptanceRate = 0;
        }
        
        
        /* var acceptanceRateChartData=
        {   labels:['Tačno %', 'Netačno %'],
            datasets:[{
                    data:[userAcceptanceRate, 100-userAcceptanceRate],
                    backgroundColor:['#5775c5', '#a7535e'], 
                    hoverBackgroundColor:['#071744','#2b0509']
            }]
        } */
        
        var userTotalSolvedRate;
        if(numOfProblems === 0){
            userTotalSolvedRate = 0;
        }else{
            userTotalSolvedRate = Math.round((userData.userTotalSolved.count/numOfProblems)*100);
        }
        return(
            <div className={'mt-3 col-10 offset-1'}>
                <div className={'row'}>
{/***********************************LEFT SIDE****************************************************/}
{/*********************************BASIC INFO*****************************************************/}
                    <div className={'col-md-4'}>
                        <div className="card-container">
                            <Card className={'p-0 pt-4'}>
                                <CardTitle className={'text-center'}>
                                    <div className={'row'}>
                                        <div className={'col'}>
                                            Osnovne informacije
                                        </div>
                                        {
                                            showEditButton === true &&
                                            <div className={'col-3 p-0'}>
                                                <Button color='primary' onClick={()=>{editCallback()}}><span className="fa fa-pencil"> </span></Button>
                                            </div>
                                        }
                                    </div>
                                </CardTitle>
                                <hr/>
                                <CardBody className={'pb-2'}>
                                    <div className={"d-flex justify-content-center mt-2"}>
                                        <img style = {{borderRadius: "50%"}} src = {imgPath}
                                            width = {250} height = {250} alt = {""}/>
                                    </div>
                                    {
                                    (userData.userInfo.firstName !== null || userData.userInfo.lastName !== null) &&
                                        <div    className={'text-center mt-1 studentName ml-1 mr-1'}
                                                style={{wordBreak:'break-word'}}>
                                            {userData.userInfo.firstName} {userData.userInfo.lastName}
                                        </div>
                                    }
                                    <div className={'row mt-2 d-flex justify-content-center'}>
                                        <RenderUserSocialInfo   info = {userData.userInfo.email}
                                                                faClass = "fa-at"
                                                                link = {"mailto: " + userData.userInfo.email}/>

                                        <RenderUserSocialInfo   info = {userData.userInfo.websiteURL}
                                                                faClass = "fa-link"
                                                                link = {userData.userInfo.websiteURL}/>

                                        <RenderUserSocialInfo   info = {userData.userInfo.linkedin}
                                                                faClass = "fa-linkedin-square"
                                                                link = {"https://www.linkedin.com/in/" + userData.userInfo.linkedin}/>

                                        <RenderUserSocialInfo   info = {userData.userInfo.github}
                                                                faClass = "fa-github"
                                                                link = {"https://www.github.com/" + userData.userInfo.github}/>

                                        
                                    </div>
                                    {
                                        userData.userInfo.dateOfBirth !== null &&
                                        <p className="text-center mt-1 pb-0">
                                            <span className={'fa fa-birthday-cake ml-2'} title="Rođendan"></span>
                                            {convertDate(userData.userInfo.dateOfBirth)}
                                        </p>
                                    }
                                </CardBody>    
                            </Card>
                        </div>
{/****************************************END OF BASIC INFO***************************************/}

{/***************************************OTHER INFORMATIONS***************************************/}
                        {/* <Card>
                            <CardTitle className={'text-center'}>Informacije o uspešnosti</CardTitle>
                            <hr/>
                            <CardBody>
                                {
                                /*rangListPosition will be -1 if user is still not ranked
                                    userData.rangListPosition !== -1 &&
                                    <p className={'text-center'}>
                                        <span className={'fa fa-line-chart ml-2'}></span>
                                        {userData.rangListPosition}
                                    </p>
                                }
                                <ListGroup className="mt-2">
                                    <ListGroupItem className={'row d-flex justify-content-between p-0'}>
                                        <div className='col'>
                                            <p>Ukupno pokušaja</p>
                                        </div>
                                        <div className='col-2 p-0'>
                                            <Badge pill color='primary'>
                                                {userData.userTotalSubmissions.count}
                                            </Badge>
                                        </div>
                                    </ListGroupItem>

                                    <ListGroupItem className={'row d-flex justify-content-between p-0'}>
                                        <div className='col'>
                                            <p>Rešeno zadataka</p>
                                        </div>
                                        <div className='col-2 p-0'>
                                            <Progress value = {userData.userTotalSolved.count} 
                                                    color={userTotalSolvedRate >= 80 ? 'success' : 
                                                    userTotalSolvedRate >= 50 ? 'info' : 'warning'}
                                                    max={numOfProblems}
                                                    className="mt-1">
                                            {userData.userTotalSolved.count}/{numOfProblems}
                                            </Progress>
                                            
                                        </div>
                                    </ListGroupItem>

                                    <ListGroupItem className={'row d-flex justify-content-between p-0'}>
                                        <div className='col'>
                                            <p>Procenat uspešnosti</p>
                                        </div>
                                        <div className='col-2 p-0'>
                                            <Badge pill color = 'primary'>
                                                {userAcceptanceRate}%
                                            </Badge>
                                        </div>
                                    </ListGroupItem>

                                </ListGroup>
                                {/*
                                    userData.userTotalSubmissions.count !== 0 &&
                                    <Doughnut
                                        data={acceptanceRateChartData}
                                        legend={{
                                            "display": true,
                                            "position": "top",
                                            "fullWidth": true,
                                            "reverse": false,
                                            "labels": {
                                                "fontColor": "rgb(0, 0, 0)"
                                            }
                                        }}
                                        height={200}
                                        width={200}
                                    />
                                }
                                
                            </CardBody>
                        </Card> */}
{/***************************************CONTRIBUTIONS DATA***************************************/}
                                                <div className="card-container">
                            <Card>
                                <CardTitle className={'text-center'}> Statistike </CardTitle>
                                <hr/>
                                <CardBody>
                                    {
                                    /*rangListPosition will be -1 if user is still not ranked*/
                                        userData.rangListPosition !== -1 &&
                                        <p className={'text-center'}>
                                            <span className={'fa fa-line-chart ml-2'}></span>
                                            {userData.rangListPosition}
                                        </p>
                                    }
                                    <ListGroup className="mt-2">
                                        <ListGroupItem className={'row d-flex justify-content-between p-0'}>
                                            <div className='col'>
                                                <p>Ukupno pokušaja</p>
                                            </div>
                                            <div className='col-2 p-0'>
                                                <Badge pill color='primary'>
                                                    {userData.userTotalSubmissions.count}
                                                </Badge>
                                            </div>
                                        </ListGroupItem>

                                        <ListGroupItem className={'row d-flex justify-content-between p-0'}>
                                            <div className='col'>
                                                <p>Rešeno zadataka</p>
                                            </div>
                                            <div className='col-2 p-0'>
                                                <Progress value = {userData.userTotalSolved.count} 
                                                        color={userTotalSolvedRate >= 80 ? 'success' : 
                                                        userTotalSolvedRate >= 50 ? 'info' : 'warning'}
                                                        max={numOfProblems}
                                                        className="mt-1">
                                                {userData.userTotalSolved.count}/{numOfProblems}
                                                </Progress>
                                                
                                            </div>
                                        </ListGroupItem>

                                        <ListGroupItem className={'row d-flex justify-content-between p-0'}>
                                            <div className='col'>
                                                <p>Procenat uspešnosti</p>
                                            </div>
                                            <div className='col-2 p-0'>
                                                <Badge pill color = 'primary'>
                                                    {userAcceptanceRate}%
                                                </Badge>
                                            </div>
                                        </ListGroupItem>

                                    </ListGroup>
                                    {/*
                                        userData.userTotalSubmissions.count !== 0 &&
                                        <Doughnut
                                            data={acceptanceRateChartData}
                                            legend={{
                                                "display": true,
                                                "position": "top",
                                                "fullWidth": true,
                                                "reverse": false,
                                                "labels": {
                                                    "fontColor": "rgb(0, 0, 0)"
                                                }
                                            }}
                                            height={200}
                                            width={200}
                                        />
                                    */}
                                    
                                </CardBody>
                            </Card>
                        </div>
                        
                    </div>
{/*******************************************RIGHT SIDE*******************************************/}
                    <div className={'col-md-8'}>
                        {/*acitivty heatmap*/}
                        <div className="card-container">
                            <Card className={'text-center'}>
                                <CardTitle> Svi pokušaji u poslednjih godinu dana </CardTitle>
                                <hr/>
                                <CalendarHeatmap
                                    startDate={startDate}
                                    endDate={endDate}
                                    values = {userData.userActivity}
                                    classForValue={(value) => {
                                        if (!value || value.count === 0) {
                                            return 'colorEmpty';
                                        }
                                        else{
                                            if(value.count < 25)
                                                return 'colorScaleActivity' + Math.floor(value.count/5);
                                            else
                                                return 'colorScaleActivity6';
                                        }
                                    }}
                                    gutterSize = {2}
                                    titleForValue={(value)=>{
                                            if(!value){
                                                return "Nema pokušaja";
                                            }
                                            return "Broj pokušaja: " + value.count
                                        }}
                                    monthLabels={monthLabels}
                                    
                                />
                            </Card>
                        </div>
                        {/*success heatmap*/}
                        <div className="card-container">
                            <Card className={'text-center'}>
                                <CardTitle> Uspešni pokušaji u poslednjih godinu dana </CardTitle>
                                <hr/>

                                <CalendarHeatmap
                                                startDate={startDate}
                                                endDate={endDate}
                                                values = {userData.userSuccess}
                                                classForValue={(value) => {
                                                    if (!value || value.count === 0) {
                                                    return 'colorEmpty';
                                                    }
                                                    else{
                                                        if(value.count < 25)
                                                            return 'colorScaleSuccess'+Math.floor(value.count/5);
                                                        else
                                                            return 'colorScaleSuccess6';                        
                                                    }
                                                }}
                                                gutterSize={2}
                                                titleForValue={(value)=>{
                                                    if(!value){
                                                        return "Nema tačnih rešenja"
                                                    }
                                                    return "Broj tačnih rešenja: " + value.count
                                                }}
                                                monthLabels={monthLabels}
                                />
                            </Card>
                        </div>
                        <div className="card-container">
                            <Card className={'pb-0'}>
                                <CardTitle className={'text-center'}> Doprinosi </CardTitle>
                                <hr/>
                                <CardBody className={'pb-2'}>
                                    <div className={'row'}>
                                        <div className={'col'}>
                                            Poslato zadataka
                                        </div>
                                        <div className={'col-2'}>
                                            <Badge pill color='primary'>
                                                {userData.userContributions.count}
                                            </Badge>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>

                        {/*last submissions
                        <RenderLastSubmissions  data={userData.userLastSubmissions}/>
                        */}

                    </div>
                    
                </div>
            </div>
        );
    }
    else return null;

}

function RenderUserSocialInfo({info, faClass, link}){
    if(info !== null){
        return(
            <React.Fragment>
                <a href={link} className='col d-flex justify-content-center default-link'>
                    <span className={'fa ' + faClass + ' studentContact'}></span>
                </a>
            </React.Fragment>
        );
    }
    else{
        return(
            <span className={'col fa ' + faClass + ' studentContact'}></span>
        );
    }
}

/* function RenderLastSubmissions({data}){
    var submissions = data.map((submission)=>{
        var badgeColor = submission.isCorrect === 1 ? 'success' : 'danger';
        var badgeText = submission.isCorrect === 1 ? 'Tačno' : 'Netačno';
        return(
            <ListGroupItem key={submission.idProblemSubmission}>
                <div className={'row'}>
                    <div className={'col'}>
                        <div className={'container'}>
                            <div className={'row'} style={{fontWeight:'bold'}}>
                                {submission.name}
                            </div>
                            <div className={'row'}>
                                {convertDatetime(submission.timestamp)}
                            </div>
                        </div>
                    </div>
                    <div className={'col-2'}>
                    </div>
                    <div className={'col-2'}>
                        <Badge pill color={badgeColor}>{badgeText}</Badge>
                    </div>
                </div>
            </ListGroupItem>
        );
    })
    return(
        <React.Fragment>
            <Card>
                <CardTitle className={'text-center'}> Skoriji pokušaji </CardTitle>
                <hr/>
                <ListGroup>
                    {submissions}
                </ListGroup>
            </Card>
        </React.Fragment>
    );
} */
export default StudentPage;
